import styled, { keyframes } from 'styled-components';

const wobbleKeyframe = keyframes`
  0%, 100% {
    -webkit-transform: translateX(0%);
    transform: translateX(0%);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
  }
  15% {
    -webkit-transform: translateX(-3px) rotate(-2deg);
    transform: translateX(-3px) rotate(-2deg);
  }
  30% {
    -webkit-transform: translateX(calc(3px / 2)) rotate(2deg);
    transform: translateX(calc(3px / 2)) rotate(2deg);
  }
  45% {
    -webkit-transform: translateX(calc(-3px / 2)) rotate(calc(-2deg / 1.8));
    transform: translateX(calc(-3px / 2)) rotate(calc(-2deg / 1.8));
  }
  60% {
    -webkit-transform: translateX(calc(3px / 3.3)) rotate(calc(2deg / 3));
    transform: translateX(calc(3px / 3.3)) rotate(calc(2deg / 3));
  }
  75% {
    -webkit-transform: translateX(calc(-3px / 5.5)) rotate(calc(-2deg / 5));
    transform: translateX(calc(-3px / 5.5)) rotate(calc(-2deg / 5));
  }
`

export const HeaderStyled = styled.div`
  width: 100%;
  min-height: 80px;
  display: flex;
  border-bottom: 1px solid ${(props) => props.theme.color.divider};
  background: ${(props) => props.theme.color.white};
  position: fixed;
  top: 41px;
  left: 0;
  z-index: 1100;
  transition: top 0.3s ease;
  a {
    color: inherit;
    text-decoration: none;
  }
  flex-direction: column;

  &.fixed {
    top: 0;
  }

  &.hide-header{
    display:none;
  }

  .container {
    max-width: 1300px;
    padding: 16px !important;
  }
  .content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 !important;

    .searchBox {
      width: 100%;
    }
  }

  .searchGlobalBox {
    width: 100%;
    input {
      padding: 12px 40px 12px 40px;
    }
  }

  .mobileSearchBox {
    display: none;
  }

  .menuButton {
    cursor: pointer;
    display: flex;
    align-items: center;
    margin: 0 30px 0 0;

    .ic {
      width: 18px;
      height: 18px;
      display: flex;
      margin: 0 10px 0 0;

      svg {
        width: 100%;
        max-height: 100%;
        path {
          filter: none;
        }
      }

      &.hide {
        display: none;
      }
    }

    > .label {
      font-weight: 600;
      color: ${(props) => props.theme.text.dark};
      &.hide {
        display: none;
      }
    }
  }

  .logo {
    width: 105px;
    min-width: 105px;
    height: 40px;
    display: flex;
    align-items: center;
    margin: 0 30px 0 0;
    cursor: pointer;

    a {
      display: flex;
    }

    img {
      width: 100%;
      max-height: 100%;
    }
  }

  .loginSignup {
    position: relative;
    display: flex;
    align-items: center;
    margin: 0 0 0 30px;

    .profile_view {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .user_ic {
        margin-left: 8px;
      }
    }

    .ic {
      width: 34px;
      display: flex;
      margin: 0 10px 0 0;
      border-radius: 50%;
      overflow: hidden;
    }

    > .label {
      font-weight: 600;
      white-space: nowrap;

      a {
        color: ${(props) => props.theme.text.dark};
        text-decoration: none;
        :hover {
          text-decoration: underline;
        }
      }
    }

    .user-name {
      max-width: 136px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .notificationBox {
    display: flex;
    align-items: center;
    margin: 0 0 0 30px;
    cursor: pointer;
    position: relative;

    .notificationDropdown {
      position: absolute;
      z-index: 1;
    }

    .ic {
      width: 20px;
      height: 20px;
      position: relative;

      img {
        width: 20px;
      }

      .dot {
        width: 12px;
        height: 12px;
        border: 2px solid ${(props) => props.theme.color.white};
        background: ${(props) => props.theme.color.red};
        border-radius: 50%;
        position: absolute;
        top: -4px;
        right: -4px;
      }

      .badge {
        width: 18px;
        height: 18px;
        font-size: 11px;
        font-weight: 700;
        color: ${(props) => props.theme.color.white};
        background: ${(props) => props.theme.blue.dark};
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: -7px;
        right: -7px;
      }
    }
  }

  .pointBox {
    display: flex;
    align-items: center;
    margin: 0 0 0 30px;
    position: relative;

    .ic {
      width: 34px;
      height: 34px;
      margin: 0 8px 0 0;
      background: ${(props) => props.theme.mandalay.dark}20;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      background-size: 18px;
      border-radius: 50%;
      display: flex;
      justify-content: centner;
      align-items: center;

      > div {
        margin: 0 auto !important;
      }
    }
    .ic-secure {
      width: 78px;
      height: 28px;
      margin: 0 8px 0 0;
      background-repeat: no-repeat;
    }
    .value {
      font-size: 16px;
      font-weight: 700;
      line-height: 100%;
      color: ${(props) => props.theme.mandalay.dark};
    }
    .label {
      font-size: 11px;
      font-weight: 600;
      line-height: 100%;
      color: ${(props) => props.theme.text.medium};
    }
  }

  .cartBox {
    display: flex;
    align-items: center;
    margin: 0 15px 0 30px;
    cursor: pointer;
    position: relative;

    .ic {
      width: 20px;
      height: 22px;
      position: relative;

      img {
        width: 20px;
      }

      .badge {
        width: 24px;
        height: 24px;
        font-size: 14px;
        font-weight: 700;
        color: ${(props) => props.theme.color.white};
        background: ${(props) => props.theme.green.dark};
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: -15px;
        right: -15px;
      }
    }
    &.cartWobble{
      animation: ${wobbleKeyframe} 1s ease infinite;
    }
  }
  .notification-scroll {
    .nContent {
      max-height: calc(100vh - 207px);
      overflow: auto;
    }
  }

  @media (max-width: 820px) {
    .notificationBox {
      .notificationDropdown {
        position: absolute;
        z-index: 3;
      }
    }

    .container {
      padding: 0;
    }
    .content {
      justify-content: flex-start;

      .searchBox {
        display: none;
      }
    }
    .menuButton {
      margin: 0 15px 0 0;

      .ic {
        margin-right: 0;
      }

      .label {
        display: none;
      }
    }
    .logo {
      margin: 0 auto 0 0;
    }
    .notificationBox {
      margin: 0 0 0 auto;
    }

    .mobileSearchBox {
      display: flex;
      margin: 10px 0 0 0;
    }
    .loginSignup {
      margin: 0 0 0 15px;

      .ic {
        margin: 0;
      }

      .user-name {
        margin-left: 10px;
      }
      .label {
        display: none;
      }
    }
    .pointBox {
      margin: 0 0 0 15px;

      .ic {
        margin: 0;
      }
      .details {
        display: none;
      }
    }
    .cartBox {
      margin: 0 15px 0 15px;
    }
  }

  @media (max-width: 767px) {
    &.topZero {
      top: 0;
    }
    .notificationBox {
      .notificationDropdown {
        position: absolute;
        z-index: 3;
        right: -150px;
        transform: translateX(0);
        &::before {
          right: 149px;
        }
        &::after {
          right: 150px;
        }
      }
    }
    .pointBox {
      .ic-secure {
        display: none;
      }
    }
  }
  @media (max-width: 480px) {
    .notification-scroll {
      .nContent {
        max-height: calc(100vh - 243px);
        overflow: auto;
      }
    }
    .notificationBox {
      .notificationDropdown {
        min-width: 345px;
        max-width: 345px;
      }
    }
  }
  @media (max-width: 380px) {
    .logo {
      width: 80px;
      height: 23px;

      > div {
        width: 80px;
        height: 23px;
      }
    }
    .menuButton {
      .ic {
        width: 15px;
        height: 15px;
      }
    }
    .loginSignup {
      margin-left: 12px;
      .ic {
        width: 30px;
      }
    }
    .notificationBox {
      .ic {
        width: 16px;
        height: 16px;
      }
    }
    .cartBox {
      margin-left: 12px;
      .ic {
        width: 16px;
        height: 16px;

        .badge {
          width: 18px;
          height: 18px;
          font-size: 10px;
          top: -10px;
          right: -10px;
        }
      }
    }
    .pointBox {
      margin-left: 12px;
      .ic {
        width: 30px;
        height: 30px;
      }
    }
  }
  &.rtl {
    .content{
      .menuButton {
        margin: 0 0 0 30px;
        @media (max-width: 820px) {
          margin: 0 0 0 15px;
        }
        .ic {
          margin: 0 0px 0 10px;
        }
      }
      .logo {
        margin: 0 0 0 15px;
      }
    }
  }
`;
